export default __webpack_public_path__ + "static/media/donnor.be8f7c4d.jpg";